import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";

import {
    _dataFromMap,
    _initSplitBarEvent,
} from "../comJs";

import {
    stationPanelUtils,
    initStationTypeSelComEvent
} from "../../../jsCom/goAclDialog/components/stationCommon";
import GoTabUrl from "../goTabsUrl";
import GridPanelUtils from "./gridPanelUtils";

class StationTab extends TabCell {


    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);

        let tabCellId="station";
        this.tabIdName = tabCellId;
        this.dataFrom = "station";
        this.dataFromLabel = "岗位";

        this.tabLabel = _dataFromMap[tabCellId];

        this.active = false;
        this.hasType=vueObj.hasType;
        this.hasSaveGroup = false;
        if (AssertUtils.isNotEmpty(vueObj.value)) {
            this.defVals = vueObj.value;
        }
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    /**
     * 获取左边cell的内容
     * @param panelHeight
     */
    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.panelHeight = panelHeight;
        let pabelHeight = panelHeight - 70 + "px";
        return `${stationPanelUtils.getStationPanelHeader(this)} 
            <div class="depart-tree-div" >
              <div id="${
            this.tabId
            }_left_top_cell_grid" style="height: ${pabelHeight}"></div>
            </div> 
      `;
    }

    //将数据添加到已选表格中
    addStationRecordToAlreadyGrid(rowId, orgGrid, dataFromLabel) {
        stationPanelUtils._addStationRecordToAlreadyGrid(this, rowId, orgGrid, dataFromLabel);
    }

    /**
     * 初始化 已选数据表格
     * @param panelHeight
     */
    getRightCellContent(panelHeight) {
        return stationPanelUtils.initRightCellContent(panelHeight, this);
    }

    /**
     * 初始化左边岗位表格信息
     */
    initStationGrid() {
        let cellObj = this;
        //是否可以选中岗位
        cellObj.itemConfig["selStation"] = true;
        //记录点击事件
        let clickFun = function (rowId) {
            let selGrid = cellObj.stationGrid;
            //如果是单选 则需要特殊处理
            if (cellObj.goTabs["count"] === 1) {
                //循环已选数据里面存在于单选表格的数据 则进行删除 而把选中的数据添加进来
                let alreadGrid = cellObj.alreadySelGrid;
                alreadGrid.forEachRow(function (rowId) {
                    alreadGrid.deleteRow(rowId);
                });
                cellObj.addStationRecordToAlreadyGrid(rowId, selGrid, cellObj.dataFromLabel);
            } else {
                let dataJson = selGrid.getRowRecord(rowId);
                //表示选中
                if (dataJson.selBox === 1 || dataJson.selBox === "1") {
                    cellObj.addStationRecordToAlreadyGrid(rowId, selGrid, cellObj.dataFromLabel);
                } else {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                }
            }
        };
        cellObj.stationGrid = stationPanelUtils.initStationGrid(cellObj, true, true, true, true, clickFun,false);
    }



    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, this.dataFromLabel,"name",this.dataFrom);
    }


    //初始化tabcell的容器控件
    initTabCellCtl() {
        var tabCellObj = this;
        //待选数据
        this.initStationGrid();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            //查询左边待选表格
            searchFun: () => {
                tabCellObj.stationGrid.reloadData(stationPanelUtils.getLoadGridParams(this));
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        //初始化账套缺省默认值
        stationPanelUtils.initStationTypeDefVal(this);
        this.initCtlEvent();

    }

    loadSysDefData() {

    }

    //选择账套信息
    changeAccountEvent(nodeId, cellObj) {
        //重新加载岗位表格信息
        cellObj.stationGrid.flushGridByUrl({params:stationPanelUtils.getLoadGridParams(cellObj),url:GoTabUrl.queryStationByAccount(nodeId),backFun: () => {
            cellObj.initFirstData = true;
            cellObj.excludeIds&&cellObj.excludeIds.forEach((recordId)=>{
                if(AssertUtils.isNotEmpty(recordId)){
                    cellObj.stationGrid.deleteRow(recordId);
                }
            });
        }});
    }

    /**
     * 初始化岗位类别选择事件
     */
    initStationTypeSelEvent() {
        let cellObj = this;
        let selStationTypeFun = function () {
            //根据岗位类型查询岗位表格刷新数据
            cellObj.stationGrid.reloadData(stationPanelUtils.getLoadGridParams(cellObj));
        };
        //输入框事件
        initStationTypeSelComEvent(this.tabId, selStationTypeFun);
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        //初始化岗位类别选择事件
        this.initStationTypeSelEvent();
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);

    }

    allCheckBoxClick() {
    }


    destructionTab() {
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.stationGrid != null && AssertUtils.isFunction(this.stationGrid.destructor)) {
            this.stationGrid.destructor();
            this.stationGrid = null;
        }
    }

    /**
     * 移除已选数据的时候  移除左边选中的状态
     * @param rId
     * @param dataFrom
     */
    removeSelectedRecord(rId) {
        this.stationGrid.setRowIsNotSelected(rId);
    }
}

function initStationTab(goTabs, vueObj) {
    let groupTab = new StationTab(vueObj, goTabs);
    goTabs.addTabToFactory("station", groupTab);
}

export default initStationTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/stationTab.js